// React Query 키를 여러 컴포넌트가 공유해야 할 때만 여기에 둔다.
// (한 컴포넌트 안에서만 쓰는 키는 그 파일에 인라인으로 두는 편이 읽기 쉽다)

// 회원 상세 헤더/회원정보 탭이 함께 쓰는 이용 정보(addition-info).
// 포인트 적립·차감, 메모 저장 후 이 키를 invalidate 하면 헤더 숫자가 갱신된다.
export const MEMBER_ADDITION_INFO_KEY = (memberId, branchId) => ['member-addition-info', memberId, branchId];
